import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { formatUrl } from '@utils/text';

type LocationState = {
  from?: string;
};

export const useGetPreviousPageUrl = () => {
  const {
    settings: { websiteHostAddress },
  } = useApplicationBuildContext();

  const location = useLocation();

  return useMemo(() => {
    const documentReferrer = document.referrer;
    const state = location.state as LocationState;
    return state?.from ? formatUrl({ urlBase: websiteHostAddress, path: state?.from }) : documentReferrer;
  }, [location, websiteHostAddress]);
};
